module.exports = __webpack_public_path__ + "img/Abrollbehälter_Container.1bc65cda.svg";